export enum STOCK_STATUS {
    OUT_OF_STOCK = 0,
    IN_STOCK = 1,
    SOON_AVAILABLE = 2,
    SOON_OUT_OF_STOCK = 3,
    ONLY_IN_SHOP = 4,
    IN_STOCK_FROM = 5,
}

export enum PlansCmsBlocks {
    SENSATION = 'zone_fiche_tel_forfaits-sensation-cms',
    SENSATION_PRO = 'zone_fiche_tel_forfaits-sensation-pro-cms',
    SIMO = 'zone_fiche_tel_forfaits-simo-cms',
    SIMO_PRO = 'zone_fiche_tel_forfaits-simo-pro-cms',
    SOWO = 'zone_fiche_tel_forfaits-bandyou-cms',
}

export enum TIME_LAPSE {
    DAY,
    WEEK,
    FUTURE,
}
